import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast, Zoom } from "react-toastify";
import { useMedia } from "react-use";
import { Col, Image, Row, Typography } from "antd";
import { CONVERSATION_FILTER_TYPE, STORAGE_KEYS } from "constants/appConstant";
import moment from "moment";
import { AuthInfo } from "stores/slices/auth";
import {
  doGetConversationDetail,
  doGetConversationPage,
  doUpdateConversation,
  filterStatus,
  getConversationSelected,
  setConversationList,
  setConversationSelected,
  setParamsConversation,
} from "stores/slices/conversation";
import { setHeaderTitle } from "stores/slices/layout";
import { doGetUserByWorkspace, getUserDetail } from "stores/slices/user";
import { workspaceUserDetail } from "stores/slices/workspaceUser";
import { onMessageListener } from "useFirebase/firebase";
import StorageHelper from "utils/storeHelper";

import "react-toastify/dist/ReactToastify.css";

import sound from "../../../assets/images/mixkit-bell-notification-933.mp3";

import ChatCustomerInfo from "./chatCustomerInfo";
import ChatMessage from "./chatMessage";
import Conversation from "./conversation";

const InboxPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstRenderPage = useRef(true);

  const urlParam = useParams();
  const below768 = useMedia("(min-width: 769px)");
  const authInfo = useSelector(AuthInfo);
  const conversationSelected = useSelector(getConversationSelected);
  const workspaceUser = useSelector(workspaceUserDetail);
  const userInfo = useSelector(getUserDetail);
  const filterStatusConversation = useSelector(filterStatus);
  const [isOpenLayoutRight, setIsOpenLayoutRight] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState(null);
  const [isLoadingConversation, setIsLoadingConversation] = useState(true);
  const [conversations, setConversations] = useState([]);

  const filterStatusCon = StorageHelper.getLocalItem(
    STORAGE_KEYS.filterStatusConversation
  );
  const [params, setParams] = useState({
    workspaceId: authInfo?.workspaceId,
    pageNumber: 1,
    pageSize: 10,
    sortField: "sendTimeMessage",
    sortDirection:
      filterStatusCon !== null &&
      filterStatusCon !== CONVERSATION_FILTER_TYPE.AWAITING_REPLIES
        ? "DESC"
        : "ASC",
    filterConversation:
      filterStatusCon !== null &&
      filterStatusCon !== CONVERSATION_FILTER_TYPE.AWAITING_REPLIES
        ? filterStatusCon
        : CONVERSATION_FILTER_TYPE.AWAITING_REPLIES,
  });

  const loadData = async () => {
    // setIsLoadingConversation(true);
    const { payload } = await dispatch(doGetConversationPage(params));
    if (payload && payload.status === 200) {
      let newConversationList;

      if (
        params &&
        (params.filterConversation === CONVERSATION_FILTER_TYPE.ALL ||
          params.filterConversation === CONVERSATION_FILTER_TYPE.MY_REPLIES)
      ) {
        newConversationList = payload.data.content.filter(
          item => !item.blockUser
        );
      } else {
        newConversationList = [...payload.data.content];
      }

      setConversations([...newConversationList]);
      dispatch(setConversationList(newConversationList));
      if (newConversationList && newConversationList.length > 0) {
        handleUnlockConversation(newConversationList);
        // Remove draft message from conversation list
        handleRemoveDraftMessage(newConversationList);
      }
      await dispatch(setParamsConversation(params));
      setIsLoadingConversation(false);
    }
    setIsLoadingConversation(false);
  };

  const handleFormatTime = timestamp => {
    const browserLocale = navigator.language;
    const momentTimestamp = moment(timestamp)
      .tz(userInfo?.timeZone ? userInfo?.timeZone : moment.tz.guess())
      ?.locale(browserLocale)
      .format("LT");
    return momentTimestamp;
  };

  const handleOpenChatMessage = body => {
    if (body && body.conversationId) {
      navigate(`/inbox/${body.conversationId}`);
      getDetailConversation(body.conversationId);
      const newParams = {
        workspaceId: authInfo?.workspaceId,
        pageNumber: 1,
        pageSize: 10,
        sortField: "sendTimeMessage",
        sortDirection: "DESC",
        filterConversation: "ALL",
      };
      setParams(newParams);
    }
  };

  const getDetailConversation = async id => {
    if (id) {
      const { payload } = await dispatch(doGetConversationDetail({ id: id }));
      if (payload && payload.status === 200) {
        await dispatch(setConversationSelected(payload.data));
      }
    }
  };

  const MsgToast = data => {
    if (data && data.messageNotification) {
      const { body, notification } = data.messageNotification;
      return (
        <div onClick={() => handleOpenChatMessage(body)}>
          <Typography.Title
            level={5}
            style={{
              marginBottom: 8,
              width: "auto",
              maxWidth: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {notification?.title}
          </Typography.Title>
          <div
            style={{
              width: "auto",
              maxWidth: "270px",
              whiteSpace: "normal",
            }}
          >
            {notification?.image !== undefined ? (
              <>
                <Image
                  width={50}
                  height={50}
                  src={notification?.image}
                  preview={false}
                />
              </>
            ) : (
              <>
                <Typography.Text>{body?.message}</Typography.Text>
              </>
            )}
          </div>

          <div style={{ marginTop: 8 }}>
            <Typography.Text style={{ fontSize: 12 }}>
              {handleFormatTime(
                moment(
                  moment.tz(body?.createdTime, "MMM DD, YYYY hh:mm:ss A", "UTC")
                )
              )}
            </Typography.Text>
          </div>
        </div>
      );
    }
  };

  const displayToastMessage = messageNotification => {
    if (workspaceUser.availableNewMessage && !conversationSelected.mute) {
      const messageSound = new Audio(sound);
      if (messageSound) {
        messageSound.play();
      }
      if (
        messageNotification &&
        messageNotification.body &&
        messageNotification.body.message === "" &&
        messageNotification.body.mediaContents &&
        messageNotification.body.mediaContents.length > 0
      ) {
        switch (messageNotification.body.mediaContents[0].mediaContentType) {
          case "IMAGE":
            messageNotification.body.message = `Attachment: ${messageNotification.body.mediaContents.length} Image`;
            toast(<MsgToast messageNotification={messageNotification} />, {
              position: "bottom-right",
              autoClose: 8000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
              limit: 3,
              transition: Zoom,
              stacked: true,
            });
            break;
          case "FILE":
            messageNotification.body.message = `Attachment: ${messageNotification.body.mediaContents.length} File`;
            toast(<MsgToast messageNotification={messageNotification} />, {
              position: "bottom-right",
              autoClose: 8000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
              limit: 3,
              transition: Zoom,
              stacked: true,
            });
            break;
          case "VIDEO":
            messageNotification.body.message = `Attachment: ${messageNotification.body.mediaContents.length} Video`;
            toast(<MsgToast messageNotification={messageNotification} />, {
              position: "bottom-right",
              autoClose: 8000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
              limit: 3,
              transition: Zoom,
              stacked: true,
            });
            break;
          case "AUDIO":
            messageNotification.body.message = `Attachment: ${messageNotification.body.mediaContents.length} Audio`;
            toast(<MsgToast messageNotification={messageNotification} />, {
              position: "bottom-right",
              autoClose: 8000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
              limit: 3,
              transition: Zoom,
              stacked: true,
            });
            break;
          default:
            break;
        }
      } else {
        toast(<MsgToast messageNotification={messageNotification} />, {
          position: "bottom-right",
          autoClose: 8000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          limit: 3,
          transition: Zoom,
          stacked: true,
        });
      }
    }
  };

  useEffect(() => {
    onMessageListener().then(payload => {
      console.log("payload", payload);
      let messageNotification = {
        notification: payload.notification,
        body: JSON.parse(payload.data.content),
        type: payload.data.type,
      };
      setNotificationMessage(messageNotification);
    });
  });

  const getUserByWorkspace = async () => {
    const request = {
      workspaceId: authInfo && authInfo.workspaceId,
    };
    await dispatch(doGetUserByWorkspace(request));
  };

  const handleUnlockConversation = async conversationList => {
    let request;
    if (conversationList && conversationList.length > 0) {
      conversationList.forEach(async conversationItem => {
        //  Unlock conversation
        if (
          authInfo?.id === conversationItem?.lockUserId &&
          conversationItem?.lock
        ) {
          request = {
            id: conversationItem?.id,
            lockConversation: false,
          };
          await dispatch(doUpdateConversation(request));
        }
      });
    }
  };

  const handleRemoveDraftMessage = conversationList => {
    if (conversationList && conversationList.length > 0) {
      conversationList.forEach(conversationItem => {
        StorageHelper.removeLocalItem(conversationItem.id);
      });
    }
  };

  useEffect(() => {
    if (authInfo && authInfo.workspaceId) {
      loadData();
    }
  }, [params]);

  useEffect(() => {
    const currentConversationId = StorageHelper.getLocalItem(
      STORAGE_KEYS.currentConversationId
    );
    if (conversations && conversations.length > 0) {
      if (isFirstRenderPage.current && currentConversationId === null) {
        navigate(`/inbox/${conversations[0].id}`);
        dispatch(setConversationSelected(conversations[0]));
        isFirstRenderPage.current = false;
      } else {
        const index = conversations.findIndex(
          item => item.id === currentConversationId
        );
        if (index !== -1) {
          navigate(`/inbox/${conversations[index].id}`);
          dispatch(setConversationSelected(conversations[index]));
        }
      }
    }
    if (
      conversations &&
      conversations.length === 0
      // &&
      // id === "messages"
    ) {
      navigate(`/inbox/messages`);
    }
  }, [conversations]);

  useEffect(() => {
    if (notificationMessage?.body?.id !== undefined) {
      displayToastMessage(notificationMessage);
    }
  }, [notificationMessage?.body?.id]);

  useEffect(() => {
    dispatch(setHeaderTitle("inbox"));

    getUserByWorkspace();

    return () => {
      handleUnlockConversation(conversations);
      dispatch(setConversationSelected(null));
      StorageHelper.removeLocalItem(STORAGE_KEYS.currentConversationId);
      StorageHelper.removeLocalItem(STORAGE_KEYS.filterStatusConversation);
    };
  }, []);

  useEffect(() => {
    if (filterStatusConversation) {
      StorageHelper.setLocalItem(
        STORAGE_KEYS.filterStatusConversation,
        filterStatusConversation
      );
    }
  }, [filterStatusConversation]);

  return (
    <>
      <div
        style={{
          background: "#fff",
          width: "100%",
          height: "calc(100vh - 64px)",
          overflowY: "hidden",
        }}
      >
        <Row
          style={{
            width: "100%",
          }}
        >
          <Col xs={6} sm={6} md={8} lg={12} xl={10} xxl={6}>
            <Conversation
              below768={below768}
              params={params}
              setParams={setParams}
              filterStatusCon={filterStatusCon}
              isLoadingConversation={isLoadingConversation}
            />
          </Col>
          <Col xs={18} sm={18} md={16} lg={12} xl={14} xxl={18}>
            <ChatMessage
              below768={below768}
              isOpenLayoutRight={isOpenLayoutRight}
              setIsOpenLayoutRight={setIsOpenLayoutRight}
              isLoadingConversation={isLoadingConversation}
              conversationSelected={conversationSelected}
            />
          </Col>
          <ChatCustomerInfo
            urlParam={urlParam}
            isOpenLayoutRight={isOpenLayoutRight}
            setIsOpenLayoutRight={setIsOpenLayoutRight}
            authInfo={authInfo}
          />
        </Row>
      </div>
    </>
  );
};
export default InboxPage;
